module.exports = __webpack_public_path__ + "static/logo-stamp-beige-777a8a6d4b87667b99c81ea7b630c8a1.svg";